import SanityClient from "./client";
import imageUrlBuilder from "@sanity/image-url";

const builder = imageUrlBuilder(SanityClient);

export const urlFor = (source) => {
  return builder.image(source);
};
